import type { Tier } from '../../Perks/hooks/useTiers'

export const getSelectedTierIds = (
  tierIds: number[],
  availableTiers: Tier[] = [],
): Record<string, boolean> =>
  availableTiers.reduce((acc, tier) => {
    return {
      ...acc,
      [tier.id]: tierIds.indexOf(tier.id) !== -1,
    }
  }, {})
